import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as SkeletonMui } from '@mui/material';
export default function Skeleton(props) {
    return _jsx(SkeletonMui, Object.assign({}, props));
}
